import React from 'react'
import { useIntl } from 'react-intl'
import { notifyFrame } from 'Helpers/notifyParent'
import {
  evalCondition,
  notifyParent,
  storeGet,
  STORE_KEY_ACCOUNT
} from 'mailup-react-helpers'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Checkbox
} from 'mailup-web-components'
import styled from '@emotion/styled'

import {
  inputState,
  INPUT_VALUE_CUSTOM_URL,
  isButtonDisabledState
} from '../recoil/state/input'
import { confirmShortUrlCallback } from '../recoil/callbacks/callbacks'

const Footer = () => {
  const intl = useIntl()

  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )

  const isDisabled = useRecoilValue(isButtonDisabledState)
  const [{ trackDetails, radioValue }, setInput] = useRecoilState(inputState)
  const getUrl = useRecoilCallback(confirmShortUrlCallback, [])

  const handleChange = () => {
    if (!isDisabled) {
      setInput(prev => ({ ...prev, trackDetails: !trackDetails }))
    }
  }

  const handleConfirm = async () => {
    const insertUrl = await getUrl()
    notifyParent('insertUrl', [insertUrl])
  }

  const handleGoToShop = () => {
    notifyFrame('top', 'redirectMainFrame', ['mshop_Redirector.aspx?t=mshopem'])
  }

  return (
    <Flex alignItems='center' justifyContent='flex-end'>
      {IsTrial && radioValue === INPUT_VALUE_CUSTOM_URL && showMshop ? (
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleGoToShop}
          data-mu-test='button__go-to-shop'
        >
          {intl.formatMessage({ id: 'Load.Common.Upgrade' })}
        </Button>
      ) : (
        <>
          <FlexItem>
            <LeftButton
              kind={BUTTON_VARIANT_SECONDARY}
              onClick={handleChange}
              disabled={isDisabled}
              data-mu-test='button__track-clicks'
            >
              <Checkbox
                checked={trackDetails}
                value={trackDetails}
                onChange={handleChange}
                disabled={isDisabled}
                data-mu-test='checkbox__track-clicks'
              />
              {intl.formatMessage({
                id: 'Load.LinkUrlSelection.TrackingDetails'
              })}
            </LeftButton>
          </FlexItem>
          <FlexItem>
            <RightButton
              kind={BUTTON_VARIANT_PRIMARY}
              onClick={handleConfirm}
              disabled={isDisabled}
              data-mu-test='button__confirm'
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
            </RightButton>
          </FlexItem>
        </>
      )}
    </Flex>
  )
}

export default Footer

const LeftButton = styled(Button)`
  border-radius: 4px 0 0 4px !important;
`
const RightButton = styled(Button)`
  border-radius: 0 4px 4px 0 !important;
`
